<template>
  <div>
    <vs-prompt
      :title="isNew ? 'Add tax rate' : 'Update tax rate'"
      @cancel="val = ''"
      @accept="accept"
      @close="close"
      :active.sync="prompt"
      :accept-text="isNew ? 'Add' : 'Update'"
      :is-valid="validForm"
      class=""
    >
      <vs-row>
        <vs-col vs-w="12">
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Code</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full">
              <vs-input v-model="code" />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Rate</span>
            </div>
            <div class="vx-col sm:w-4/5">
              <vs-input-number
                style="max-width: 150px"
                v-model="taxRatePercentage"
                :min="0"
                :max="100"
                :step="1"
              />
            </div>
          </div>
        </vs-col>
      </vs-row>
    </vs-prompt>
  </div>
</template>


<script>
import { mapGetters } from "vuex";
export default {
  components: {},
  data() {
    return {
      existingId: null,
      code: "",
      taxRatePercentage: 25,
      prompt: false,
    };
  },
  computed: {
    ...mapGetters({}),
    isNew() {
      return !this.existingId;
    },
    validForm() {
      return this.code && this.code.length > 0;
    },
  },
  methods: {
    show(withStorage) {
      this.code = "";
      //   this.taxRate = 0.25;
      this.existingId = null;
      this.taxRatePercentage = 25;

      if (withStorage) {
        this.existingId = withStorage.taxGroupId.id;
        this.code = withStorage.code;
        this.taxRatePercentage = withStorage.taxRatePercentage;
        // this.taxRate = withStorage.taxRate;
      }
      this.prompt = true;
    },
    async accept() {
      const dto = {
        taxRatePercentage: parseInt(this.taxRatePercentage),
        code: this.code,
      };

      if (this.isNew) {
        dto.taxGroupId = this.uuidv4();
        this.$store.commit("pos/countrySettings/createTaxGroup", dto);
      } else {
        dto.taxGroupId = this.existingId;
        this.$store.commit("pos/countrySettings/updateTaxGroup", dto);
      }
    },
    uuidv4() {
      return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
        (
          c ^
          (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
        ).toString(16)
      );
    },
    close() {},
  },
};
</script>

<style lang="scss" scoped>
</style>
